import { memo } from 'react'

import { useMapResultsQuery } from '../../hooks/useQueries'

import Map from '../../components/maps/Map'
import { centerFromBounds } from '../../components/maps/Map/mapUtils'
import { MapMode } from '../../components/layout/ItemGridWithMap/useWhichMapMode'

import MarkerCallout from './MarkerCallout'
import NoResultsMessage from './NoResultsMessage'

type SearchViewMapProps = {
  filters: GQL_SearchFilters
  searchQuery: string
  mapMode: MapMode
}

const SearchMap = memo((props: SearchViewMapProps) => {
  const { filters, searchQuery, mapMode } = props

  const { type, ne, sw } = filters

  const center = centerFromBounds({ ne, sw })

  const { data, loading } = useMapResultsQuery({
    variables: { params: filters },
  })

  const results = data?.search?.mapResults ?? []

  const showNoResultsMessage =
    !loading && mapMode === 'toggle' && results.length === 0

  return (
    <>
      <Map
        filters={filters}
        results={results}
        loading={loading}
        searchQuery={searchQuery}
        analyticsSource="search"
        PopupComponent={MarkerCallout}
        defaultCenter={center}
      />

      {showNoResultsMessage && <NoResultsMessage searchType={type} />}
    </>
  )
})

export default SearchMap
